export const styles = {
    root: {
      height: "100%"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
    },
    alert: {
      border: "4px solid #e91e63"
    },
    range: {
      marginTop: "8px"
    },
    card: {
      height: "100%"
    },
    cardActions: {
      justifyContent: "space-between"
    },
    contentContainer: {
      paddingTop: 0,
      paddingBottom: "5px", 
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: 'center',
      alignItems: "center"
    },
    header: {
      marginTop: "5px",
      padding: "10px"
    },
    yAxisLabel: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "-10px",
      color: "white",
      marginBottom: "2px",
      marginLeft: "5px"
    },
    chartContainer: {
      display: "flex"
    },
    chart: {
    
    }
  }


// WEBPACK FOOTER //
// ./src/styles/card-styles.js